<template>
  <div id="app">
    <section class="hero is-info">
        <div class="hero-body">
          <p class="title has-text-centered">
            GERAKAN PANDAI EVENT
          </p>
        </div>
      </section>
      <div class="container-1056">
        <div class="card" style="background-image: linear-gradient(0deg, #FFFFFF 67.46%, #DDF2FA 100%) ; background-repeat: no-repeat; background-size: cover">
          <div class="card-image">
            <figure class="image is-3by3" style="object-position: center; object-fit: contain">
              <img :src="getPictureEvent(event.pic_event)" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <figure class="image is-48x48">
                  <img src="../assets/bukuCI.png" alt="Placeholder image">
                </figure>
              </div>
              <div class="media-content">
                <p class="title is-4">{{event.nama_event}}</p>
                <p class="subtitle is-6">
                  Uploaded:
                  <b-icon
                      icon="timer"
                      size="is-small">
                  </b-icon>
                    {{new Date(event.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
                </p>
              </div>
            </div>

            <div class="content">
              <p class="font-18 font-bold"> Tanggal Pelaksanaan :</p>
              <div v-if="event.tgl_event !==null">
                <p class="font-18">{{new Date(event.tgl_event).toLocaleDateString('id-ID',{day:'numeric',month:'long',year:'numeric'}) }}</p>
              </div>

              <div v-else-if="event.tgl_event===null">
                -
              </div>
              <p class="font-18 font-bold mt-16">Link Drive</p>
              <p v-html="event.linkdrive"  style="font-size:17px;"></p>
              <p class="font-18 font-bold">Deskripsi</p>{{ event.deskripsi}}
            </div>
          </div>
        </div>
      </div>
      <!-- <section>
        <div>
          <div class="card-image" style="margin-left:10%;margin-right:10%;margin-top:0">
          <figure class="image is-3by3" style="object-position: center; object-fit: contain">
            <img :src="getPictureEvent(event.pic_event)" alt="Placeholder image">
          </figure>
        </div>
        <br>
        <div class="rows container-1056">
          <div class="row">
            <div class="columns" style="padding-left:20px">
              <div class="column is-3">
                  Uploaded:
                  <b-icon
                      icon="timer"
                      size="is-small">
                  </b-icon>
                    {{new Date(event.created_at).toLocaleDateString('id-ID',{year:'numeric',month:'long',day:'numeric'}) }}
                  <p style="font-weight:bold;font-size:14px"> Tanggal Pelaksanaan :</p>
                <div v-if="event.tgl_event !==null">
                    <p style="font-size:40px;color:blue;width:50px" class="image animate__animated animate__backInUp">{{new Date(event.tgl_event).toLocaleDateString('id-ID',{ day:'numeric'}) }}</p>
                    <p  style="font-size:20px;color:blue;">{{new Date(event.tgl_event).toLocaleDateString('id-ID',{month:'long',year:'numeric'}) }}</p>
                  </div>

                  <div v-else-if="event.tgl_event===null">
                    -
                  </div>
              </div>
              <div class="border"></div>
              <div class="column is-5"><h1 class="image animate__animated animate__backInUp has-text-centered;" style="color:blue; font-size:25px"><b>{{event.nama_event}}</b></h1>
                <p style="font-weight:bold;font-size:14px">Pembicara</p>
                <p style="font-size:16px" class="image animate__animated animate__backInUp"> {{ event.pembicara}}</p>
                <p style="font-weight:bold;font-size:14px">Tempat Acara</p>
                <p style="font-size:16px" class="image animate__animated animate__backInUp"> {{ event.tempat_event}}</p>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="rows container-1056">
            <p style="font-weight:bold;font-size:14px">Link Drive</p>
            <p v-html="event.linkdrive"  style="font-size:17px;"></p>
            <p style="font-weight:bold;font-size:14px">Deskripsi</p>
            <p style="font-size:18px" class="image animate__animated animate__backInUp">{{ event.deskripsi}}</p>
          </div>
        </div>
      </section> -->
    <section class="hero is-info">
        <div class="rows">
            <div class="row">
                <div class="column">
                  <b-button  class="button is-info" 
                    tag="router-link"
                    to="/homepage"
                    icon-left="arrow-left-bold">Back to Home</b-button>
                </div>
            </div>
        </div>     
      </section>
  </div>
</template>

<script>
export default {
  data() {
      return {
        carousel:true,
        isLoading: false,
        event:'',
        events:[],
        id_event:'',
        acara:Object,
        berita:Object,
        isDetail:false,
        config: {},

        test: 0,
      }
  },
  methods: {
    getDataEvent(id_event)
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'event/' + id_event

      this.$http.get(uri).then(response =>
      {
        this.event = response.data.value
        
      })

    },
    getPictureEvent(pic_event){
        var uri = this.$apiUrl + 'event/picture/' + pic_event
          
        return uri;
      },
    snackbar(snackbarMessage,type)
    {
        this.$buefy.toast.open({
            duration : 5000,
            message: snackbarMessage,
            type: type,
            position: 'is-top',
            actionText :'OK',
            queue: false,
        })
    },
    
  },
  computed: {
  },
  mounted()
  {
    if(this.$route.params.id) {           
    this.id_event = this.$route.params.id
    this.getDataEvent(this.id_event)  
  }
    console.log(this.search)
  
  }
}
</script>


<style scoped>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.border{
  border-right-style: solid;
   border-width: 3px;
}


/* Style the header */
.header {
  background-color: #f1f1f1;
  padding: 20px;
  text-align: center;
}

/* Style the top navigation bar */
.topnav {
  overflow: hidden;
  background-color: #333;
}

/* Style the topnav links */
.topnav a {
  float: left;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}

/* Change color on hover */
.topnav a:hover {
  background-color: #ddd;
  color: black;
}


/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 33.33%;
  padding: 15px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
@media screen and (max-width:600px) {
  .column {
    width: 100%;
  }
}

</style>